<template>
  <div>
    <CardedSectionHeader
      icon="mdi-form-select"
      label="District Preview"
      id="admin_delete_district_details"
    ></CardedSectionHeader>
    <div class="pt-4 pb-4 white text-right pr-8">
      <v-btn @click="$router.go(-1)" small rounded outlined color="default">
        <v-icon left>mdi-trash-can</v-icon> Cancel Delete
      </v-btn>
    </div>
    <CardedDisplay>
      <ViewHeader
        :title="district.name"
        :icon="'mdi-flag'"
        :img_src="'https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1605870956/botswana%20services/website%20assets/map-full_qlxnxa.png'"
        :facts="view_header_facts"
        :description="''"
      ></ViewHeader>
    </CardedDisplay>
    <CardedSectionHeader
      icon="mdi-trash-can"
      label="Delete District Concent Form "
      id="admin_delete_district_form"
    ></CardedSectionHeader>
    <DeleteConcentForm
      ref_prop="districts_delete_form_ref"
      id="districts_delete_form"
      message="<b>Delete was succesfull</b> <br/> District has been removed"
      :is_loading="is_loading"
      :seed="{district:[$route.params.id]}"
      @on-delete-success="on_success"
      @on-hide-loader="$emit('on-hide-loader')"
      @on-show-loader="$emit('on-show-loader')"
    >
    </DeleteConcentForm>
  </div>
</template>

<script>
import CardedSectionHeader from "../../../components/CardedSectionHeader";
import CardedDisplay from "../../../components/CardedDisplay";
import CardedForm from "../../../components/CardedForm";
import ViewHeader from "../../../components/ViewHeader";
import DeleteConcentForm from "../../../components/DeleteConcentForm";
import ServerClient from "../../../lib/ServerClient";
import Utils from "../../../lib/Utils";
export default {
  name: "AdminDistrictsDelete",
  components: {
    CardedSectionHeader,
    CardedDisplay,
    ViewHeader,
    CardedForm,
    DeleteConcentForm,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      district: {
        id: 0,
        name: "",
        short_name: "",
        country: {
            id: 0,
            name: ""
        }
      },
      errors: [],
      message: "",
      not_found: false,
      records: null,
      total: 0,
      scan_limit: 0,
    };
  },
  methods: {
    on_success() {
      //go back to districts list
      this.$router.push("/admin/locations/districts/list");
    },
    load_district() {
      this.$emit("on-show-loader");
      ServerClient.Locations.get_district(
        {
          id: this.$route.params.id,
          is_edit: true,
        },
        (res) => {
          this.$emit("on-hide-loader");
          console.log("district to be deleted ", res);
          if (res == null) {
            this.not_found = true;
          } else {
            this.district = res;
          }
        },
        (errors) => {
          this.$emit("on-hide-loader");
          console.log(
            "Errors while loading district details on admin delete districts",
            errors
          );
        }
      );
    },
  },
  computed: {
    view_header_facts() {
      var facts = [
        { text: "Country:", val: this.district.country.name },
      ];
      return facts;
    },
  },
  mounted() {
    var district_id = this.$route.params.id;
    this.$emit("set-page-attributes", {
      title: "Admin delete District",
      crumps: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin",
        },
        {
          text: "Locations",
          disabled: false,
          href: "/admin/locations",
        },
        {
          text: "Cities",
          disabled: false,
          href: "/admin/locations/districts/list",
        },
        {
          text: "View",
          disabled: false,
          href: "/admin/locations/districts/list/view/" + district_id,
        },
        {
          text: "Delete",
          disabled: true,
          href:"/admin/locations/districts/list/view/"+district_id+"/delete" 
        }
      ],
      navbar_cols: 3
    });
    this.load_district();
  },
};
</script>